/**
 * Marker for a guest → account upgrade whose upload has not finished yet. It is
 * written before the account is registered, so a page load during the upload
 * still finds it and the provider resumes the upload on the next boot.
 *
 * The value is the real account's user id. The provider only resumes when that
 * account is the tab's active one.
 */
export const GUEST_UPGRADE_PENDING_KEY = "dailyjournal_guest_upgrade_pending";

export function markGuestUpgradePending(userId: string): void {
  try {
    globalThis.localStorage.setItem(GUEST_UPGRADE_PENDING_KEY, userId);
  } catch {
    // Best-effort: the upload still runs in this page.
  }
}

export function readGuestUpgradePending(): string | null {
  try {
    const raw = globalThis.localStorage.getItem(GUEST_UPGRADE_PENDING_KEY);
    return raw === null || raw === "" ? null : raw;
  } catch {
    return null;
  }
}

/** Clears the marker only when it still names `userId` (a newer upgrade keeps its own). */
export function clearGuestUpgradePending(userId: string): void {
  try {
    if (globalThis.localStorage.getItem(GUEST_UPGRADE_PENDING_KEY) === userId) {
      globalThis.localStorage.removeItem(GUEST_UPGRADE_PENDING_KEY);
    }
  } catch {
    // Nothing to clear.
  }
}
